/* PW card motion (v67 video, v68 image-safe reveal and second image crossfade, v92 play on view, v94.7 rules).
   v94.7 rules for every product card (homepage, collections, search, predictive search, shortlist, picks,
   Pairs well with, recipient tiles):
   - Card with a video (data-pw-vid, smallest mp4): phones play it muted, inline and looped once the card is
     about 60% in view; desktop plays it on hover. One video plays at a time (plus the hovered one). The video
     element is created on first use, preload metadata, poster = the first image.
   - Card without a video and with a second image: desktop crossfades to it on hover (CSS); phones cycle
     image 1 and image 2 every 2.5s while the card is about 60% in view.
   - Polish round 2 (15 Oct): runners-up cards and the pick circles cycle from 30% in view, because the runners-up
     row shows the second card only partly on phones. data-pw-delay staggers the start.
   - Reduced motion: no video, no cycling, the second image shows on hover only.
   Cards opt in with data-pw-vid on the media wrapper, or with two images inside one of ALT_SEL. */
(function () {
  if (window.__pwCardVid) return; window.__pwCardVid = 1;
  var mq = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var VID = !RM && !(conn && conn.saveData);
  var HOVER = mq('(hover: hover) and (pointer: fine)');
  var HAS_IO = 'IntersectionObserver' in window;
  var CYCLE = 2500, VIEW = 0.6, VIEW_LOW = 0.3, LOW_SEL = '.ns-picks__three, .ns-pk__stage';
  if (VID) document.documentElement.classList.add('pw-cv');
  var CARD_SEL = '.pwb-card, .card-wrapper, .ns-qs, .ns-mini, .ns-note, .ns-rt__i, .ns-pk__circ, .pw-mc, .pwps__pi, a';

  /* ---------- Second image ---------- */
  var ALT_SEL = '.card__media .media.media--hover-effect, .pwb-card__img, [data-pw-motion]';
  var altIO = null, warmIO = null;
  function viewOf(w) {
    if (w.__view === undefined) w.__view = (w.closest && w.closest(LOW_SEL)) ? VIEW_LOW : VIEW;
    return w.__view;
  }
  function altStop(w) { clearTimeout(w.__altT); clearInterval(w.__altI); w.__altT = w.__altI = 0; w.classList.remove('pw-alt-on'); }
  function altStart(w) {
    if (w.__altT || w.__altI) return;
    var d = parseInt(w.getAttribute('data-pw-delay') || '0', 10) || 0;
    w.__altT = setTimeout(function () {
      w.__altT = 0;
      w.classList.add('pw-alt-on');
      w.__altI = setInterval(function () { w.classList.toggle('pw-alt-on'); }, CYCLE);
    }, 400 + d);
  }
  function onAltIO(entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= viewOf(e.target)) altStart(e.target); else altStop(e.target);
    });
  }
  function bindAlt(w) {
    if (w.__pwAlt || (VID && w.hasAttribute('data-pw-vid'))) return;
    var imgs = [].filter.call(w.children, function (c) { return c.tagName === 'IMG'; });
    if (imgs.length < 2) return;
    w.__pwAlt = 1; w.classList.add('pw-alt');
    if (!HAS_IO) return;
    w.__alt2 = imgs[1];
    warmIO = warmIO || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { try { e.target.__alt2.loading = 'eager'; } catch (x) {} warmIO.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    warmIO.observe(w);
    if (RM || HOVER) return; /* desktop and reduced motion: hover only (CSS) */
    altIO = altIO || new IntersectionObserver(onAltIO, { threshold: [0, VIEW_LOW, VIEW] });
    altIO.observe(w);
  }

  /* ---------- Video ---------- */
  var MAX = 1, ratio = new Map(), playing = [], timer = 0, io = null;
  function show(w, v) { if (w.__want && v.videoWidth > 0 && !v.paused) w.classList.add('pw-vid-on'); }
  function hide(w) { w.classList.remove('pw-vid-on'); }
  function ensure(w) {
    if (w.__pwv) return w.__pwv;
    if (getComputedStyle(w).position === 'static') w.style.position = 'relative';
    var v = document.createElement('video');
    v.className = 'pw-cardvid';
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('loop', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.setAttribute('disablepictureinpicture', ''); v.setAttribute('disableremoteplayback', '');
    v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1');
    v.preload = 'metadata';
    var img = w.querySelector('img');
    if (img && (img.currentSrc || img.src)) v.poster = img.currentSrc || img.src;
    function frame() {
      if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(function () { show(w, v); });
      else if (v.currentTime > 0) show(w, v);
    }
    v.addEventListener('playing', frame);
    v.addEventListener('timeupdate', function () { if (v.currentTime > 0) show(w, v); });
    ['waiting', 'stalled', 'emptied', 'abort', 'pause', 'ended'].forEach(function (ev) {
      v.addEventListener(ev, function () { if (ev !== 'waiting' || v.readyState < 3) hide(w); });
    });
    v.addEventListener('error', function () {
      w.__pwBad = 1; w.__want = false; hide(w);
      try { v.removeAttribute('src'); v.load(); } catch (e) {}
      if (v.parentNode) v.parentNode.removeChild(v);
      w.__pwv = null;
    });
    w.appendChild(v); w.__pwv = v;
    return v;
  }
  var srcCache = {};
  function pick(w) {
    var fb = w.getAttribute('data-pw-vid'), h = w.getAttribute('data-pw-h');
    if (!h || !window.fetch || fb) return Promise.resolve(fb);
    if (!srcCache[h]) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      srcCache[h] = fetch(base + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var best = null, bh = 1e9;
          ((j && j.media) || []).some(function (m) {
            if (m.media_type !== 'video') return false;
            (m.sources || []).forEach(function (s) {
              if (s.format === 'mp4' && s.height >= 240 && s.height < bh) { bh = s.height; best = s.url; }
            });
            return true;
          });
          return best || fb;
        })
        .catch(function () { return fb; });
    }
    return srcCache[h];
  }
  function play(w, v) {
    if (!w.__want || w.__pwBad) return;
    try { var p = v.play(); if (p && p.catch) p.catch(function () { hide(w); }); } catch (e) { hide(w); }
    if (!v.paused && v.readyState > 2 && v.currentTime > 0) show(w, v);
  }
  function start(w) {
    if (w.__pwBad) return;
    w.__want = true;
    var v = ensure(w);
    if (v.getAttribute('src')) return play(w, v);
    pick(w).then(function (u) { if (w.__pwv !== v || !u) return; if (!v.getAttribute('src')) v.src = u; play(w, v); });
  }
  function stop(w) {
    w.__want = false; hide(w);
    if (w.__pwv) { try { w.__pwv.pause(); } catch (e) {} }
  }

  function applyView() {
    var list = [];
    ratio.forEach(function (r, w) { if (r >= viewOf(w) && w.isConnected) list.push([w, r]); });
    list.sort(function (a, b) { return b[1] - a[1]; });
    var keep = list.slice(0, MAX).map(function (x) { return x[0]; });
    playing.forEach(function (w) { if (keep.indexOf(w) < 0 && !w.__hov) stop(w); });
    keep.forEach(function (w) { if (playing.indexOf(w) < 0 || !w.__pwv || w.__pwv.paused) start(w); });
    playing = keep.filter(function (w) { return !w.__pwBad; });
  }
  function onIO(entries) {
    entries.forEach(function (e) {
      ratio.set(e.target, e.isIntersecting ? e.intersectionRatio : 0);
      if (e.intersectionRatio < viewOf(e.target) && playing.indexOf(e.target) > -1) { stop(e.target); playing.splice(playing.indexOf(e.target), 1); }
    });
    clearTimeout(timer); timer = setTimeout(applyView, 250);
  }

  function bind(w) {
    if (w.__pwBound || !w.getAttribute('data-pw-vid')) return;
    w.__pwBound = 1;
    if (HOVER) {
      var card = w.closest(CARD_SEL) || w;
      card.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen' || !e.pointerType) { w.__hov = true; start(w); } });
      card.addEventListener('pointerleave', function () { w.__hov = false; stop(w); });
    } else if (HAS_IO) {
      io = io || new IntersectionObserver(onIO, { threshold: [0, 0.3, 0.45, 0.6, 0.75, 0.9, 1] });
      io.observe(w);
    }
  }
  function scan(rootEl) {
    var r = rootEl || document;
    r.querySelectorAll(ALT_SEL).forEach(bindAlt);
    if (VID) r.querySelectorAll('[data-pw-vid]').forEach(bind);
  }
  window.pwCardVidScan = scan;

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) playing.concat([]).forEach(stop);
    else applyView();
  });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  function init() {
    scan();
    var t2 = 0;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { clearTimeout(t2); t2 = setTimeout(scan, 120); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { scan(); });
})();